
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.58 9H4.228C1.922 9 0 10.907 0 13.196v28.608C0 44.093 1.922 46 4.228 46h45.544C52.078 46 54 44.093 54 41.804V13.196C53.808 10.906 51.886 9 49.58 9zM26.904 42.948c-8.648 0-15.566-6.865-15.566-15.448s6.918-15.45 15.566-15.45S42.47 18.917 42.47 27.5s-6.92 15.448-15.566 15.448zm21.139-25.556h-2.114c-1.153 0-2.114-.954-2.114-2.099 0-1.144.96-2.098 2.114-2.098h2.114c1.153 0 2.114.954 2.114 2.098 0 1.145-.961 2.099-2.114 2.099z","fill":"#000"}}),_c('path',{attrs:{"d":"M33.585 0h-9.17c-2.147 0-4.098 1.453-4.683 3.528L17 11h24l-2.732-7.472C37.488 1.453 35.537 0 33.585 0zM10.538 6H7.461C6.231 6 5 6.833 5 8h8c0-1.167-1.026-2-2.462-2zm7.752 22.547a8.583 8.583 0 01.29-3.411c1.037-3.54 4.292-6.143 8.153-6.189v-2.314c0-.128.16-.197.266-.119l4.76 3.498c.079.06.079.18 0 .235l-4.755 3.498c-.11.078-.266.009-.266-.12v-2.309a6.233 6.233 0 00-5.638 3.82 6.15 6.15 0 00.876 6.276 1.183 1.183 0 01-.225 1.698 1.194 1.194 0 01-1.643-.23 8.487 8.487 0 01-1.818-4.333zm13.745-4.444a6.13 6.13 0 011.359 3.55 6.189 6.189 0 01-.483 2.726c-.932 2.213-3.098 3.783-5.637 3.82v-2.31c0-.128-.161-.197-.266-.119l-4.761 3.498c-.078.06-.078.18 0 .235L27.003 39c.11.078.266.009.266-.12v-2.313c3.86-.042 7.12-2.645 8.153-6.189a8.68 8.68 0 00.29-3.411 8.443 8.443 0 00-1.814-4.334 1.195 1.195 0 00-1.643-.23 1.189 1.189 0 00-.22 1.7z","fill":"#000"}})])
          )
        }
      }
    